module.exports = __webpack_public_path__ + "85de323d3273ec8988abab19fc77f820.png";